import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    PAYOUT_FAILURE,
    PAYOUT_LOAD,
    PAYOUT_SUCCESS
} from './payoutActions';
import { getEntityByName } from '../appEntities';

const initialState = {
    loading: false,
    isChargebackLoading: false,
    isChargebackError: false,
    chargeback: null
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {

        case PAYOUT_LOAD:
            newState = {
                ...state,
                payout: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_SUCCESS:
            newState = {
                ...state,
                loading: false,
                payout: action.payout
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getPayoutEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payout')
);

export const getIsPayoutLoading = createSelector(
    getPayoutEntity,
    (entity) => get(entity, 'loading')
);

export const getPayoutError = createSelector(
    getPayoutEntity,
    (entity) => get(entity, 'error')
);

export const getPayoutErrorMessage = createSelector(
    getPayoutError,
    (error) => get(error, 'message')
);

export const getPayout = createSelector(
    getPayoutEntity,
    (entity) => get(entity, 'payout')
);
